var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#7088A1","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","transform":"translate(2 2)"},[React.createElement("circle",{"cx":"7","cy":"7","r":"7","key":0}),React.createElement("path",{"d":"M7 9.8V7M7 4v-.5","key":1})]));
}

Info.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Info;

Info.default = Info;
